// Auto-generated normalizer for table: Cat_Recursos
export function catRecursosNormalize(row) {
  return {
    idRecurso: row.idRecurso ?? row.IdRecurso ?? row['IdRecurso'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    tipo: row.tipo ?? row.Tipo ?? row['Tipo'] ?? '',
    ruta: row.ruta ?? row.Ruta ?? row['Ruta'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['FechaRegistro'] ?? null,
  };
}
